import React, { PureComponent } from 'react';
import { connect } from 'react-redux'
import injectSheet from 'react-jss'
import cn from 'classnames'
import Spinner from "./Widgets/Spinner"
import LinkButton from './Widgets/LinkButton'

import {loadMoreArticles} from "../actions"
import {isLoadingMore, hasMorePages} from "../selectors"

class LoadMoreArticlesButton extends PureComponent {

    _handleLoadMore = () => {
        const {handleLoadMore, isLoading} = this.props;
        if(isLoading) return;
        handleLoadMore();
    }

    render() {

        const {classes, className, isLoading, hasMore} = this.props;

        return <div>
            <section className={cn(classes.container, className)} data-cy="loadMoreSection">
                {hasMore && !isLoading && <LinkButton className={classes.button} onClick={this._handleLoadMore} link={{ label: 'Load More' }} />}
                {!hasMore && <div>THE END</div>}
                <Spinner show={isLoading} />
            </section>
        </div>
    }
}

const mapStateToProps = (state) => {
    return {
        isLoading: isLoadingMore(state),
        hasMore: hasMorePages(state)
    }
}

function mapDispatchToProps(dispatch) {
    return {
        handleLoadMore: () => {
            dispatch(loadMoreArticles())
        }
    }
}

export default injectSheet( (theme) => ({
  container: {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    alignItems: 'center',
    ...theme.font.link
  },
  button: {
    fontSize: theme.getRemValue(12),
    padding: [15, 34, 13, 34],
    letterSpacing: '0.3px',
    lineHeight: 1,
    borderColor: theme.colors.faintGrey,
    borderRadius: '2px',
    transition: `background-color 0.2s ${theme.animation.easing.accelerationCurve}`,
    "&:hover": {
      color: theme.colors.white,
      backgroundColor: theme.colors.lightBlue,
      borderColor: theme.colors.lightBlue
    }
  }
}))(connect(mapStateToProps, mapDispatchToProps)(LoadMoreArticlesButton));



// WEBPACK FOOTER //
// ./src/components/LoadMoreArticlesButton.js